import request from '@/utils/request'

export function splrInfor(param) {
    let data = param
    return request({
        url: `/supplier/splrInfor/splrInfor`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function updateSmsInformation(param) {
    let data = param
    return request({
        url: `/supplier/splrInfor/updateSmsInformation`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}


